(ns portal.user-account-page.db.change-password
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Change Password")

(def ui-messages
  {:success "Successfully changed password"
   :failure "Failed to change password"})

(defn has-enough-chars?
  [password]
  (>= (count password) 8))

(defn has-uppercase?
  [password]
  (boolean (re-find #"[A-Z]" password)))

(defn has-lowercase?
  [password]
  (boolean (re-find #"[a-z]" password)))

(defn has-digit?
  [password]
  (boolean (re-find #"\d" password)))

(defn passwords-match?
  [password]
  (let [new-password @(rf/subscribe [:form.change-password/value [:new-password]])]
    (= password new-password)))

(spec/def ::old-password
  (spec/and (complement str/blank?)
            has-enough-chars?
            has-uppercase?
            has-lowercase?
            has-digit?))

(spec/def ::new-password
  (spec/and (complement str/blank?)
            has-enough-chars?
            has-uppercase?
            has-lowercase?
            has-digit?))

(spec/def ::repeat-password
  (spec/and (complement str/blank?)
            passwords-match?))

(spec/def ::value
  (spec/keys :req-un [::old-password ::new-password ::repeat-password]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser has-enough-chars?
  [_ problem]
  {:message "Password too short"
   :in (:in problem)
   :problem problem})

(p/defphraser has-uppercase?
  [_ problem]
  {:message "Password requires at least one uppercase character"
   :in (:in problem)
   :problem problem})

(p/defphraser has-lowercase?
  [_ problem]
  {:message "Password requires at least one lowercase character"
   :in (:in problem)
   :problem problem})

(p/defphraser has-digit?
  [_ problem]
  {:message "Password requires at least one digit"
   :in (:in problem)
   :problem problem})

(p/defphraser passwords-match?
  [_ problem]
  {:message "Passwords don't match"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.change-password ::value)))

(def initial-value
  {:old-password ""
   :new-password ""
   :repeat-password ""})

(def forward-events
  [{:events #{:resource.auth/change-password-success}
    :dispatch-to [:form.change-password/submit-success]}
   {:events #{:resource.auth/change-password-failure}
    :dispatch-to [:form.change-password/submit-failure]}])

(form/register-form {:namespace :form.change-password
                     :forward-events forward-events
                     :initial-value initial-value
                     :validate-form validate-form
                     :submit-event :form.change-password/submit-form})

(rf/reg-event-fx :form.change-password/submit-form
  (fn [_ [_ payload]]
    {:dispatch-n [[:loader/open]
                  [:resource.auth/change-password (select-keys payload [:old-password
                                                                        :new-password])]]}))

(rf/reg-event-fx :form.change-password/submit-success
  (fn [{:keys [db]}]
    {:db (-> db
             (assoc-in [:form.change-password :value] initial-value)
             (update-in [:form.change-password] dissoc :backend-error))
     :dispatch-n [[:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :success
                    :message (:success ui-messages)}]]}))

(rf/reg-event-fx :form.change-password/submit-failure
  (fn [{:keys [db]} [_ [event error-response]]]
    (let [error-message (get-in error-response [:value :error :message])]
      {:db (assoc-in db [:form.change-password :backend-error] error-message)
       :dispatch-n [[:loader/close]
                    [:response-handler/handle-response
                     {:entity-name entity-name
                      :type :error
                      :event event
                      :response error-response
                      :message (:failure ui-messages)}]]})))

(rf/reg-sub :form.change-password/has-new?
  (fn [db]
    (let [new-password (get-in db [:form.change-password :value :new-password])]
      (boolean (seq new-password)))))

(rf/reg-sub :form.change-password/has-enough-chars?
  (fn [db]
    (let [new-password (get-in db [:form.change-password :value :new-password])]
      (has-enough-chars? new-password))))

(rf/reg-sub :form.change-password/has-uppercase?
  (fn [db]
    (when-let [new-password (get-in db [:form.change-password :value :new-password])]
      (has-uppercase? new-password))))

(rf/reg-sub :form.change-password/has-lowercase?
  (fn [db]
    (when-let [new-password (get-in db [:form.change-password :value :new-password])]
      (has-lowercase? new-password))))

(rf/reg-sub :form.change-password/has-digit?
  (fn [db]
    (when-let [new-password (get-in db [:form.change-password :value :new-password])]
      (has-digit? new-password))))

(rf/reg-sub :form.change-password/backend-error
  (fn [db]
    (get-in db [:form.change-password :backend-error])))

(def use-bind-control (partial form/use-bind-control :form.change-password))
(def use-error-message (partial form/use-error-message :form.change-password))
